import List from '@service-victoria/component-library/components/List';
import Text from '@service-victoria/component-library/components/Text';
import * as Styled from './styled';
import { constants } from 'app/utils';

export default function BeforeYouStart() {
  return (
    <>
      <Text.Heading.H3 fontWeight={600}>Before you start</Text.Heading.H3>
      <Text.Body>To redeem a voucher, you’ll need:</Text.Body>
      <Styled.ListWrapper>
        <List
          type='disc'
          items={[
            'your Service Victoria login details',
            'the Get Active Kids voucher code',
            'the amount (up to $200) you want to claim',
            'the type of activity you’ll use the voucher for'
          ]}
        />
      </Styled.ListWrapper>
      <Text.Body>
        All providers must agree to follow the{' '}
        <Text.Link target='_blank' href={constants.PROGRAM_GUIDELINES_URL}>
          program guidelines
        </Text.Link>
        .
      </Text.Body>
      <Text.Heading.H3 fontWeight={600}>How we use your information</Text.Heading.H3>
      <Text.Body>
        We’ll pass on your information to the Department of Jobs, Skills, Industry and Regions
        (DJSIR) to redeem vouchers for the Get Active Kids voucher program. You can’t redeem your
        vouchers without giving us this information. DJSIR may check your information with
        Commonwealth agencies and peak Victorian sporting bodies.
      </Text.Body>
      <Text.Body>
        We won’t use your information for any other purpose unless permitted by law. You can contact
        us or DJSIR at{' '}
        <Text.Link target='_blank' href='mailto:getactivekids@sport.vic.gov.au'>
          getactivekids@sport.vic.gov.au
        </Text.Link>{' '}
        if you want to access your personal information. Learn more about how we use your
        information in the FAQ section.
      </Text.Body>
    </>
  );
}
